import { useRef, useState } from "react";

const hasFiles = (e) => Array.from(e.dataTransfer?.types || []).includes("Files");

export function FileDropZone({ as: Tag = "div", onFiles, className = "", testId, overlayTestId, children }) {
  const [dragging, setDragging] = useState(false);
  const depth = useRef(0);

  const drag = {
    onDragEnter: (e) => { if (!hasFiles(e)) return; e.preventDefault(); depth.current += 1; setDragging(true); },
    onDragOver: (e) => { if (hasFiles(e)) e.preventDefault(); },
    onDragLeave: () => { depth.current = Math.max(0, depth.current - 1); if (!depth.current) setDragging(false); },
    onDrop: (e) => {
      if (!hasFiles(e)) return;
      e.preventDefault();
      e.stopPropagation();
      depth.current = 0;
      setDragging(false);
      if (e.dataTransfer.files?.length) onFiles(Array.from(e.dataTransfer.files));
    },
  };

  return (
    <Tag {...drag} data-testid={testId}
         className={`relative rounded-lg transition-colors ${dragging ? "bg-sky-50 ring-2 ring-sky-400 ring-offset-4" : ""} ${className}`}>
      {children}
      {dragging && (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center rounded-lg
                        bg-sky-50/80 text-sm font-medium text-sky-800" data-testid={overlayTestId}>
          Drop files to upload
        </div>
      )}
    </Tag>
  );
}
